import { fromJS } from 'immutable';

export default fromJS({
    isLoginPopupOpen: false
});